import { useState, useEffect } from "react";
import PetCard from "../pets/PetCard";
import SkeletonCards from "../pets/SkeletonCards";
import { getAllData } from "../../utils";
import { Link } from "react-router-dom";

const Carousel = () => {
  const [pets, setPets] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [autoScroll, setAutoScroll] = useState(true);

  useEffect(() => {
  function parseFecha(fechaStr) {
  const [day, month, year] = fechaStr.split("/");
  return new Date(`${year}-${month}-${day}`);
}

    const fetchPets = async () => {
    try {
      const petData = await getAllData("mascota");
      const filteredPets = petData.filter(pet => pet.estado !== 2);
      filteredPets.sort((a, b) => parseFecha(b.fecha_publi) - parseFecha(a.fecha_publi));
      setPets(filteredPets);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching pets:", error);
      setLoading(false);
    }
  };

  fetchPets();
}, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (autoScroll) {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % pets.length);
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [pets.length, autoScroll]);

  const handleCardClick = (index) => {
    setCurrentIndex(index);
    pauseAutoScroll();
  };

  const pauseAutoScroll = () => {
    setAutoScroll(false);
    setTimeout(() => {
      setAutoScroll(true);
    }, 1000);
  };

  const getTranslateClass = (index) => {
    const totalCards = pets.length;
    const relativeIndex = (index - currentIndex + totalCards) % totalCards;

    if (relativeIndex === 0) {
      return "translate-x-0 scale-110 z-10";
    } else if (relativeIndex === 1) {
      return "translate-x-[100%] scale-95 opacity-80 z-0";
    } else if (relativeIndex === totalCards - 1) {
      return "-translate-x-[100%] scale-95 opacity-80 z-0";
    } else {
      return "opacity-0 pointer-events-none";
    }
  };

  return (
    <div className="relative min-w-full overflow-hidden">
      <div className="relative">
        <div className="h-[75dvh] max-h-[750px] landscape:scale-[1] scale-[0.85] landscape:h-[75dvw] flex justify-center items-center">
          {loading ? (
            <SkeletonCards />
          ) : (
            pets.map((pet, index) => (
              <Link
                to={index === currentIndex ? `/mascota/${pet.id}` : "#"}
                key={index}
                className={`absolute mx-1 transition-all duration-700 ease-in-out ${getTranslateClass(
                  index
                )}`}
                onClick={(e) => {
                  if (index !== currentIndex) {
                    e.preventDefault();
                    handleCardClick(index);
                  }
                }}
              >
                <PetCard data={pet} />
              </Link>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Carousel;
